
import theserver from '~/components/company/softwareComponent/theserver.vue'
export default {
  components: {
    theserver
  },
  // inject: ['main'],
  props: {
    softval: {
      type: Object,
      default: () => {}
    },
    titleVal: {
        type: String,
        default: ''
      }
  },
  data() {
      return {
        authenticationState:false,
        theserverIndex:0,
        theservertab:[
          {
            text:'全部服务器 31',
            index:0
          },
          {
            text:'MT4 14',
            index:1
          },
          {
            text:'MT5 17',
            index:2
          }
        ],
        detail: {},
        imgArr: [],
      };
  },
  created() {

  },
  mounted() {
    // this.open()
  },
  methods: {
    openIpDialog(item) {
      console.log('触发2');
      this.$emit('opendialog',item)
    },
    close(){
      document.body.style.overflow = 'auto'
      this.authenticationState = false
      this.detail={}
    },
    open() {
      console.log('触发1111111111111111111111111111111111');
      
      // 打开弹框
      this.getDetail()
    },
    async getDetail() {
      
      console.log('this.softval.softwareInfoId: ', this.softval.softwareInfoId);
      console.log('this.softval.associationId: ', this.softval.associationId);

      /* wikifxagg$gettraderrelatedsoftwaredetail */
      const res = await this.$api.common
        .CV3({
        traderCode: this.softval.traderCode,
        softwareInfoCode: this.softval.softwareInfoId,
        associationId: this.softval.associationId
      }, {
        Routes: 'wikifxagg$gettraderrelatedsoftwaredetail'
      })
      .catch((err) => {
        console.log(err);
        
      })
      console.log('res: ', res);
      if(res?.wikifxagg?.gettraderrelatedsoftwaredetail?.data){
        this.detail = res?.wikifxagg?.gettraderrelatedsoftwaredetail?.data
        this.authenticationState = true
        document.body.style.overflow = 'hidden'
      }
      // 获取相关软件详情页
      // this.$api.dealer
      //   .softwaredetail({
      //     traderCode: this.main.main.traderCode,
      //     softwareInfoCode: this.softval.softwareInfoId,
      //     associationId: this.softval.associationId
      //   })
      //   .then((res) => {
      //     console.log('res: ', res);
      //     console.log('成功2222222222222222222222222222222');
          
      //     for (const key in res) {
      //       this.$set(this.detail, key, res[key])
      //     }
      //     console.log('this.detail: ', this.detail);

      //     document.body.style.overflow = 'hidden'
      //     this.authenticationState = true
      //   })
    },
  }
};
